import { useEffect } from 'react';

import { syncMixpanelFlagsContext } from '@tracking/mixpanelFlagsContext';

/**
 * Keeps the Mixpanel feature-flag context in step with the active basket, so
 * flags keyed on `basket_id` bucket every participant of a shared session into
 * the same variant. In a remote appointment the passive client adopts the
 * host's basket through `useAppointmentBasketSync`, which lands here and
 * re-evaluates the flags for that basket.
 */
const useMixpanelFlagsContextSync = (basketId: Nullable<string>) => {
  useEffect(() => {
    void syncMixpanelFlagsContext(basketId);
  }, [basketId]);
};

export { useMixpanelFlagsContextSync };
